import styled from '@emotion/styled';
import { Plus } from 'lucide-react';
import { theme } from 'styles/theme/theme';
import UDButton from 'ud-ui/components/button';
import UDText from 'ud-ui/components/text';

const StageGroupEmptyTableWrapper = styled.div`
  background: #fff;
  padding: 34px 0;
`;

type StageGroupEmptyTableProps = {
  onAddClick: () => void;
};

const StageGroupEmptyBody = ({ onAddClick }: StageGroupEmptyTableProps) => {
  return (
    <StageGroupEmptyTableWrapper className="flex flex-col items-center">
      <UDText type="headline" className="mb-6">
        Команды еще не добавлены
      </UDText>
      <UDButton variant="dark" className="flex flex-row items-center" onClick={onAddClick}>
        <Plus size={16} className="mr-2" color={theme.colors.AccentNaplesYellow} />
        {/* <UDColorableIcon
          name="plus"
          componentProps={{ className: 'mr-2 text-accentNaplesYellow' }}
        /> */}
        Добавить команду
      </UDButton>
    </StageGroupEmptyTableWrapper>
  );
};

export default StageGroupEmptyBody;
